<template>
  <div>
    <NavBar />
    <AuthBySessionExpired />
    <new-product @created="paginate" />
    <div class="container">
      <b-overlay :show="loading" opacity="0.99">
        <div class="row">
          <div class="col-xl-1 col-lg-2 col-md-2 col-sm-3 col-12 pt-0">
            <v-btn class="btn-return" @click="handleToBack">
              <i class="fas fa-arrow-left mr-2 text-twenty"> </i> Voltar
            </v-btn>
          </div>
          <div class="col-xl-5 col-lg-5 col-md-6 col-sm-9 col-12 pt-0">
            <h1 class="title-pages pt-1 check-text-center">PRODUTOS</h1>
          </div>
          <div
            class="col-xl-6 col-lg-5 col-md-4 col-sm-12 col-12 pt-0 text-right"
          >
            <v-btn
              v-if="permission('write', 'product')"
              class="btn-add"
              @click="$bvModal.show('new_product')"
            >
              <i class="fas fa-plus mr-2 text-twenty"></i> ADICIONAR
            </v-btn>
          </div>
          <div class="col-xl-3 col-lg-4 col-md-5 col-sm-6 col-12 pt-0 pb-1">
            <v-text-field
              v-model="search"
              prepend-inner-icon="mdi-magnify"
              label="Digite sua pesquisa"
              outlined
              dense
              @input="paginate"
            />
          </div>
        </div>
        <div class="v-clean p-5 text-center" v-show="products.length == 0">
          <h6 class="text-center upper-text worksansr">SEM RESULTADOS!</h6>
        </div>
        <v-data-table
          v-show="products.length > 0"
          dense
          :headers="headers"
          :items="products"
          item-key="`${type}`/${id}"
          :footer-props="{
            'items-per-page-options': [50, 75, 100],
            'items-per-page-text': 'Mostrar',
          }"
          :options.sync="options"
          :server-items-length="total"
        >
          <template v-slot:[`item.unit_of_measurement_name`]="{ item }">
            {{ item.unit_of_measurement_name }}
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-btn class="btn-edit" small @click="handleToProduct(item)">
              <i class="fas fa-edit mr-2"></i>
              EDITAR
            </v-btn>
          </template>
        </v-data-table>
      </b-overlay>
    </div>
  </div>
</template>

<script>
import NavBar from "../templates/NavBar";

import AuthBySessionExpired from "../templates/Components/AuthBySessionExpired";

import NewProduct from "../templates/Product/NewProduct.vue";

import api from "../services/api";

import routes from "../routes";

import {
  formatPrice,
  formatValueOnKeyUp,
  formatValueToOnlyNumber,
  formatValueToPercentage,
  formatDate,
} from "../lib/format";

import permission from "../lib/permission";

export default {
  name: "Products",
  components: {
    NavBar,
    AuthBySessionExpired,
    NewProduct,
  },
  data() {
    return {
      total: 0,
      options: {},

      search: "",
      headers: [
        { text: "NOME", value: "name" },
        {
          text: "UNIDADE DE MEDIDA",
          value: "unit_of_measurement_name",
        },
        { text: "", value: "action", sortable: false },
      ],

      products: [],
      loading: false,
      errors: [],
    };
  },
  watch: {
    options: {
      handler() {
        this.paginate();
      },
    },
  },
  created() {
    this.retrieve();
  },
  methods: {
    permission,
    formatPrice,
    formatValueOnKeyUp,
    formatValueToOnlyNumber,
    formatValueToPercentage,
    formatDate,
    handleToBack: () => routes.go(-1),
    handleToProduct({ id }) {
      routes.push({ name: "product", params: { id } });
    },
    async retrieve() {},
    async paginate() {
      try {
        this.loading = true;

        const { page, itemsPerPage, sortBy, sortDesc } = this.options;
        const params = {
          search: this.search,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
        };
        const response = await api.get("/rest-home/product/paginate", {
          params,
        });
        const { error, errors, products, total } = response.data;

        if (error) {
          this.errors = errors;
        } else {
          this.products = products;
          this.total = total;
        }

        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
